import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Carousel } from "@faire/retailer-visitor-shared/components/Carousel/Carousel";
import { HorizontalScrollCarousel } from "@faire/retailer-visitor-shared/components/Carousel/HorizontalScrollCarousel";
import { ContentContainer, VanillaBackground } from "@faire/retailer-visitor-shared/components/GiftGuide/common";
import { AspectRatioPicture } from "@faire/retailer-visitor-shared/components/Image/AspectRatioPicture";
import { Image } from "@faire/retailer-visitor-shared/components/Image/Image";
import { optimizeImageUrlFillRectangle } from "@faire/web--source/common/images/optimizeImages";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
var GIFT_TILES = [
    {
        ctaLink: "/category/For%20the%20Host",
        displayName: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "tuuSXE",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gifts for"
                },
                {
                    type: 1,
                    value: "lineBreak"
                },
                {
                    type: 0,
                    value: "the Host"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                lineBreak: /*#__PURE__*/ _jsx("br", {})
            })
        }),
        imageUrl: "https://cdn.faire.com/fastly/d413940e75fc36d403fd5cca8605cd81ae176f7e02f1490bb60a9901ccf9563e.jpeg",
        imageAlt: "Elegant Sink and Hand Soap"
    },
    {
        ctaLink: "/category/For%20New%20Parents",
        displayName: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "48wS1J",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gifts for"
                },
                {
                    type: 1,
                    value: "lineBreak"
                },
                {
                    type: 0,
                    value: "New Parents"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                lineBreak: /*#__PURE__*/ _jsx("br", {})
            })
        }),
        imageUrl: "https://cdn.faire.com/fastly/7435d0935a0a893abbd66b55dd3273ad9f98f4c9186f40d510e59ceff1d330b0.jpeg",
        imageAlt: "Cheerful Baby Clapping Their Hands"
    },
    {
        ctaLink: "/category/For%20the%20Foodie",
        displayName: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "y2W4xn",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gifts for"
                },
                {
                    type: 1,
                    value: "lineBreak"
                },
                {
                    type: 0,
                    value: "the Foodie"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                lineBreak: /*#__PURE__*/ _jsx("br", {})
            })
        }),
        imageUrl: "https://cdn.faire.com/fastly/f25cc510bfd10bbe9ec8275acb4945f0309d141b62002f944054dd5d96ea9db8.jpeg",
        imageAlt: "Jar of Cinnamon, Hazelnut & Almond Nut Blend"
    },
    {
        ctaLink: "/category/For%20the%20Coffee%20&%20Tea%20Lover",
        displayName: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "jQjecQ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gifts for the"
                },
                {
                    type: 1,
                    value: "lineBreak"
                },
                {
                    type: 0,
                    value: "Coffee Lover"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                lineBreak: /*#__PURE__*/ _jsx("br", {})
            })
        }),
        imageUrl: "https://cdn.faire.com/fastly/ddeb5c72db2507867ffefd657361ef4b8ea034d73167b83674f2c131d25cf202.jpeg",
        imageAlt: "Bags of Coffee"
    },
    {
        ctaLink: "/category/For%20the%20Eco%20Conscious",
        displayName: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "tGodJZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Gifts for the"
                },
                {
                    type: 1,
                    value: "lineBreak"
                },
                {
                    type: 0,
                    value: "Eco-Conscious"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                lineBreak: /*#__PURE__*/ _jsx("br", {})
            })
        }),
        imageUrl: "https://cdn.faire.com/fastly/2ad90c3a83bec195eb2ef510425af621151dcee90352ce1712d1c78fb6144b00.jpeg",
        imageAlt: "Eco-friendly Wooden Toothbrushes"
    }
];
export var GiftGuideTopCarousel = function(param) {
    var onClick = param.onClick, leftAligned = param.leftAligned;
    var isSSR = useIsSSR();
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTabletAndAbove = _useViewport.isTabletAndAbove, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    var renderTile = function(tile, index) {
        return /*#__PURE__*/ _jsxs(Column, {
            children: [
                /*#__PURE__*/ _jsx(ImageLinkWrapper, {
                    to: tile.ctaLink,
                    onClick: function() {
                        if (onClick) {
                            onClick(tile.ctaLink);
                        }
                    },
                    children: /*#__PURE__*/ _jsx(AspectRatioPicture, {
                        $hideBorder: true,
                        $width: "100%",
                        $ratio: 220 / 300,
                        children: /*#__PURE__*/ _jsx(Image, {
                            placeholderColor: Core.text.inverse,
                            src: optimizeImageUrlFillRectangle({
                                url: tile.imageUrl
                            }, isSSR, 220, 300),
                            alt: tile.imageAlt
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: isMobile ? "1x" : "2x"
                }),
                /*#__PURE__*/ _jsx(TileLink, {
                    linkTo: tile.ctaLink,
                    variant: "tertiary",
                    onClick: function() {
                        if (onClick) {
                            onClick(tile.ctaLink);
                        }
                    },
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: isTabletAndAbove ? "subheadingSansMedium" : "paragraphSansRegular",
                        children: tile.displayName
                    })
                })
            ]
        }, index);
    };
    return /*#__PURE__*/ _jsxs(VanillaBackground, {
        children: [
            /*#__PURE__*/ _jsx(StyledContentContainer, {
                align: isTabletAndAbove && !leftAligned ? "center" : "flex-start",
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: isTabletAndAbove && !leftAligned ? "displayMSerifRegular" : "displaySSerifRegular",
                    as: "h1",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "G2EQuj",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Faire Gift Guide"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(CarouselContainer, {
                children: isDesktopAndAbove ? /*#__PURE__*/ _jsx(Carousel, {
                    name: "seo-gift-page-top-carousel",
                    itemsPerSlide: 5,
                    itemGap: 16,
                    padItems: true,
                    renderItem: renderTile,
                    items: GIFT_TILES
                }) : /*#__PURE__*/ _jsx(HorizontalScrollCarousel, {
                    itemsPerSlide: isMobile ? 2 : 3,
                    itemGap: 16,
                    renderItem: renderTile,
                    items: GIFT_TILES,
                    peekGapPercent: 20,
                    lateralPadding: 24
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: 48,
                    tabletAndAbove: 72,
                    desktopAndAbove: 60
                }
            })
        ]
    });
};
export var StyledContentContainer = styled(ContentContainer).withConfig({
    componentId: "sc-da578df6-0"
})([
    "padding:",
    " ",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], getSpacing("4x", "3x", "2x"), responsiveMediaQueries.tabletAndAbove, getSpacing("4x", "3x", "4x"), responsiveMediaQueries.desktopAndAbove, getSpacing("7x", "3x", "6x"));
export var CarouselContainer = styled(ContentContainer).withConfig({
    componentId: "sc-da578df6-1"
})([
    "",
    "{padding:0 ",
    ";}",
    "{padding:0 136px;}"
], responsiveMediaQueries.desktop, getSpacing("7x"), responsiveMediaQueries.xLargeAndAbove);
var TileLink = styled(Button).withConfig({
    componentId: "sc-da578df6-2"
})([
    "align-self:flex-start;"
]);
var ImageLinkWrapper = styled(Link).withConfig({
    componentId: "sc-da578df6-3"
})([
    "width:100%;"
]);
